<template>
  <v-container v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-form ref="form" validation @input="checkValidate" class="ml-3">
      <h1 class="my-3">{{title}}</h1>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-text-field
              label="Название"
              v-model="groupTitle"
              :rules="textInputRules"
              validate-on-blur
              outline
          ></v-text-field>
        </v-flex>
      </v-layout>

      <p class="title">Права группы</p>
      <v-layout row class="mb-4">
        <v-flex xs12 lg8 md8 pa-3 class="elevation-1 white">
          <div
              v-for="(access, index) in accessList"
              :key="access.id"
          >
            <v-checkbox
                :label="access.title"
                class="ma-0 pa-0"
                v-model="accessSelected"
                :value="access.id"
            ></v-checkbox>
          </div>
        </v-flex>
      </v-layout>

      <v-layout row class="pa-0 ma-0">
        <v-flex xs12 lg6 md6>
          <v-btn
              :loading="loading"
              :disabled="!valid || loading"
              color="primary"
              @click.native="loader = 'loading'"
              class="ma-0"
              @click="onClickCreateUserGroup"
          >
            {{id === null ? 'Создать' : 'Изменить'}}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      breadcrumbs: [
        {name: 'Главная', link: '/'},
        {name: 'Группы пользователей', link: '/users/group/list'}
      ],
      pageDataReady: {
        isReady: false,
        userGroupList: false,
        accessList: false
      },
      id: null,
      title: 'Новая группа пользователей',
      accessSelected: [],
      groupTitle: null,
      valid: false,
      textInputRules: [
        v => !!v || 'Обязательное поле'
      ]
    }),
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.userGroupList) {
          return false
        }
        if (!this.pageDataReady.accessList) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      checkValidate () {
        if (this.groupTitle === null || this.groupTitle === '') {
          this.valid = false
        } else {
          this.valid = true
        }
        return this.valid
      },
      async onClickCreateUserGroup () {
        let userGroupData = {
          title: this.groupTitle,
          accessIdList: []
        }

        for (let i = 0; i < this.accessSelected.length; i++) {
          userGroupData.accessIdList.push(this.accessSelected[i])
        }

        if (this.id !== null) {
          userGroupData.id = this.id
        }

        await this.$store.dispatch('createUserGroup', userGroupData)
          .then((data) => {
            if (typeof data.user_group !== 'undefined') {
              this.$router.push('/users/group/list')
            }
          })
          .catch(() => {})
      },
      onCreated () {
        this.$store.commit('setPageLoading', true)

        this.id = null
        this.groupTitle = null
        this.accessSelected = []

        this.breadcrumbs = [
          {name: 'Главная', link: '/'},
          {name: 'Группы пользователей', link: '/users/group/list'}
        ]

        if (this.$router.currentRoute.path.indexOf('/users/group/edit/') !== -1) {
          this.id = parseInt(this.$route.params.id)
          this.title = 'Редактировать группу пользователей'
          this.$store.dispatch('getUserGroupSingle', {id: this.id})
            .then(() => {
              this.pageDataReady.userGroupList = true
              this.pageDataStatus()
            })
          this.breadcrumbs.push({name: 'Редактировать группу'})
        } else {
          this.id = null
          this.title = 'Новая группа пользователей'
          this.breadcrumbs.push({name: 'Новая группа'})
          this.pageDataReady.userGroupList = true
          this.pageDataStatus()
        }
        this.$store.dispatch('getAccessList')
          .then(() => {
            this.pageDataReady.accessList = true
            this.pageDataStatus()
          })
        this.$store.commit('setPageTitle', this.title)
      }
    },
    computed: {
      loading () {
        return this.$store.getters.loading
      },
      userGroup () {
        return this.$store.getters.userGroupSingle
      },
      accessList () {
        return this.$store.getters.accessList
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      },
      userGroup (newUser, oldUser) {
        if (this.userGroup !== null) {
          this.groupTitle = this.userGroup.title
          if (this.accessList.length > 0) {
            for (let i = 0; i < this.accessList.length; i++) {
              for (let k = 0; k < this.userGroup.access_list.length; k++) {
                if (this.accessList[i].id === this.userGroup.access_list[k].id) {
                  this.accessSelected.push(this.accessList[i].id)
                  break
                }
              }
            }
          }
        }
      },
      accessList (val) {
        if (this.userGroup !== null) {
          for (let i = 0; i < this.accessList.length; i++) {
            for (let k = 0; k < this.userGroup.access_list.length; k++) {
              if (this.accessList[i].id === this.userGroup.access_list[k].id) {
                this.accessSelected.push(this.accessList[i].id)
                break
              }
            }
          }
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Users/UserGroupNew.vue